// 📁 Imports

// 💾 Variables
const openDropdownTrigger = document.querySelectorAll(
  "[data-dropdown-trigger-open]",
);

// 📐 Functions
const openDropdown = (identificator, navItem) => {
  const dropdown = document.querySelector(`[data-dropdown="${identificator}"]`);
  if (dropdown) {
    closeDropdownAll();
    dropdown.classList.remove("hidden");
  }
};
const closeDropdown = (identificator, navItem) => {};

const toggleDropdown = (identificator, navItem) => {
  const dropdown = document.querySelector(`[data-dropdown="${identificator}"]`);
  if (dropdown) {
    if (dropdown.classList.contains("hidden")) {
      closeDropdownAll();
      navItem.classList.add("text-indigo-600");
      dropdown.classList.remove("hidden");
    } else {
      navItem.classList.remove("text-indigo-600");
      dropdown.classList.add("hidden");
    }
  }
};

const closeDropdownAll = () => {
  const allDropdowns = document.querySelectorAll("[data-dropdown]");
  const navItems = document.querySelectorAll("[data-dropdown-trigger-open]");

  if (allDropdowns.length !== 0) {
    Array.from(allDropdowns).forEach((dropdown) => {
      dropdown.classList.add("hidden");
    });
  }

  if (navItems.length !== 0) {
    Array.from(navItems).forEach((navItem) => {
      navItem.classList.remove("text-indigo-600");
    });
  }
};

// 🖱️ Event listener
if (openDropdownTrigger.length !== 0) {
  Array.from(openDropdownTrigger).forEach((button) => {
    button.addEventListener("click", (e) => {
      const navItem = e.currentTarget;
      const dropdownIdentificator = e.currentTarget.dataset.dropdownTriggerOpen;

      if (dropdownIdentificator) {
        toggleDropdown(dropdownIdentificator, navItem);
      }
    });
  });
}

document.body.addEventListener("click", (e) => {
  if (e.target.closest("[data-navigation]") === null) {
    closeDropdownAll();
  }
});
